import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgManualIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M14 2.26953V6.40007C14 6.96012 14 7.24015 14.109 7.45406C14.2049 7.64222 14.3578 7.7952 14.546 7.89108C14.7599 8.00007 15.0399 8.00007 15.6 8.00007H19.7305M15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V6.8C4 5.11984 4 4.27976 4.32698 3.63803C4.6146 3.07354 5.07354 2.6146 5.63803 2.32698C6.27976 2 7.11984 2 8.8 2H12.0118C12.7455 2 13.1124 2 13.4577 2.08289C13.7638 2.15638 14.0564 2.27759 14.3249 2.44208C14.6276 2.6276 14.887 2.88703 15.4059 3.40589L18.5941 6.59411C19.113 7.11297 19.3724 7.3724 19.5579 7.67515C19.7224 7.94356 19.8436 8.2362 19.9171 8.5423C20 8.88757 20 9.25445 20 9.98822V12.5M10.609 17H8M14.109 13H8",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M22.408 17.6859C22.6723 17.5436 22.8045 17.4724 22.8379 17.3868C22.8669 17.3125 22.8588 17.2288 22.8159 17.1615C22.7665 17.084 22.623 17.0398 22.3361 16.9514L16.7222 15.2221C16.4878 15.1499 16.3706 15.1138 16.2914 15.1429C16.2225 15.1682 16.1682 15.2225 16.1429 15.2914C16.1138 15.3706 16.1499 15.4878 16.2221 15.7222L17.9514 21.3362C18.0398 21.6231 18.084 21.7665 18.1615 21.8159C18.2288 21.8588 18.3125 21.867 18.3868 21.838C18.4724 21.8045 18.5436 21.6724 18.6859 21.408L19.9318 19.0943C19.9529 19.055 19.9635 19.0354 19.9771 19.0182C19.9891 19.0029 20.0029 18.9891 20.0182 18.9771C20.0354 18.9635 20.055 18.9529 20.0943 18.9318L22.408 17.6859Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgManualIcon;
